// extracted by mini-css-extract-plugin
var _1 = "E7vrz";
var _2 = "KBLBK";
var _3 = "ye9cx";
var _4 = "n4wxR";
var _5 = "A26MO";
var _6 = "r4hLl";
var _7 = "RBy2j";
var _8 = "puAgn";
var _9 = "nOfnG";
var _a = "qSy3d";
var _b = "UxO5e";
var _c = "vjnpV";
var _d = "s9xpE";
var _e = "zJDM0";
var _f = "aks05";
var _10 = "AWx5M";
export { _1 as "base", _2 as "close", _3 as "connectionProperties", _4 as "content", _5 as "controls", _6 as "datasetLink", _7 as "deployedFromCell", _8 as "deployedFromCellButton", _9 as "deployedFromCellLink", _a as "filterByName", _b as "main", _c as "separator", _d as "snowflakeFQN", _e as "targetCell", _f as "title", _10 as "version" }
